import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Collapse } from 'antd';
import type { CollapseProps } from 'antd';
import { supportFaqEn } from '../../content/supportFaq.en';
import styles from './Support.module.css';

const Support: React.FC = () => {
  const collapseItems: CollapseProps['items'] = supportFaqEn.items.map((item) => ({
    key: item.id,
    label: item.question,
    children: (
      <div className={styles.answer}>
        {item.paragraphs?.map((paragraph) => (
          <p key={paragraph} className={styles.paragraph}>
            {paragraph}
          </p>
        ))}
        {item.steps && item.steps.length > 0 ? (
          <ol className={styles.steps}>
            {item.steps.map((step) => (
              <li key={step} className={styles.step}>
                {step}
              </li>
            ))}
          </ol>
        ) : null}
        {item.link ? (
          <Link to={item.link.to} className={styles.appLink}>
            {item.link.label}
          </Link>
        ) : null}
      </div>
    ),
  }));

  return (
    <div className={styles.support}>
      <div className={styles.container}>
        <section className={styles.section} aria-labelledby="support-title">
          <h1 id="support-title" className={styles.title}>
            {supportFaqEn.title}
          </h1>
          <p className={styles.lead}>{supportFaqEn.lead}</p>

          <h2 className={styles.faqHeading}>{supportFaqEn.faqHeading}</h2>
          <Collapse
            accordion
            items={collapseItems}
            className={styles.collapse}
            bordered={false}
          />

          <div className={styles.cta}>
            <h2 className={styles.ctaTitle}>{supportFaqEn.ctaTitle}</h2>
            <p className={styles.ctaText}>{supportFaqEn.ctaText}</p>
            <Link to="/contact">
              <Button type="primary" size="large">
                {supportFaqEn.ctaButton}
              </Button>
            </Link>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Support;
